module.exports = __webpack_public_path__ + "static/media/responsivedesigndemo.0156bf10.gif";